import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import EditMessageModal from "../EditMessageModal";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl, channel }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [editMessageOpen, setEditMessageOpen] = useState(false);

  const handleDeleteMessage = async () => {
    try { await api.delete(`/messages/${message.id}`); }
    catch (err) { toastError(err); }
  };

  // Meta's APIs (WhatsApp Cloud, Messenger, Instagram) don't support editing
  // or revoking sent messages — only the QR/session channel does.
  const isMetaChannel = ["facebook", "instagram", "whatsapp_cloud", "whatsapp_coexistence"].includes(channel);

  const canEdit = message.fromMe && !isMetaChannel &&
    (message.mediaType === "chat" || message.type === "chat") &&
    new Date().getTime() - new Date(message.createdAt).getTime() <= 900000;

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <EditMessageModal open={editMessageOpen} onClose={() => setEditMessageOpen(false)} message={message} />

      {menuOpen && anchorEl && (
        <div className="fixed inset-0 z-40" onClick={handleClose}>
          <div
            className="absolute bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl shadow-lg py-1 z-50 min-w-36"
            style={{ top: anchorEl.getBoundingClientRect().bottom + 4, right: window.innerWidth - anchorEl.getBoundingClientRect().right }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => { setReplyingMessage(message); handleClose(); }}
              className="w-full text-left px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
            >
              {i18n.t("messageOptionsMenu.reply")}
            </button>
            {message.fromMe && canEdit && (
              <button
                onClick={() => { setEditMessageOpen(true); handleClose(); }}
                className="w-full text-left px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
              >
                {i18n.t("messageOptionsMenu.edit")}
              </button>
            )}
            {message.fromMe && !isMetaChannel && (
              <button
                onClick={() => { setConfirmationOpen(true); handleClose(); }}
                className="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/20 transition-colors"
              >
                {i18n.t("messageOptionsMenu.delete")}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MessageOptionsMenu;
